export default {
  getNumbersFromString(string) {
    const regex = /\d+/g
    const stringAr = string.split(' ')
    const matches = string.match(regex)
    stringAr.forEach((word, i) => {
      matches.forEach(match => {
        if (word === match) {
          stringAr[i] = this.number2words(match)
        }
      })
    })
    return stringAr.join(' ')
  },

  number2words(n){
    const num = ['zero','one','two','three','four','five','six','seven','eight','nine','ten']
    if (n < 11){
      return num[n]
    } else {
      return n
    }
  }
}